import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Player from "@/pages/Player";
import Person from "@/pages/Person";
import Vault from "@/pages/Vault";
import Admin from "@/pages/Admin";
import Live from "@/pages/Live";
import Kids from "@/pages/Kids";
import TvHandoff from "@/pages/TvHandoff";
import Store from "@/pages/Store";
import TvInstall from "@/pages/TvInstall";
import Partners from "@/pages/Partners";
import Games from "@/pages/Games";
import Shorts from "@/pages/Shorts";
import ShortsFeed from "@/pages/ShortsFeed";
import PartnerStats from "@/pages/PartnerStats";
import { ReferralTracker } from "@/components/ReferralTracker";
import { SiteFooter } from "@/components/SiteFooter";
import { TvModeProvider } from "@/context/TvModeContext";
import { SpatialNav } from "@/components/SpatialNav";
import { QuickSearchModal } from "@/components/QuickSearchModal";
import { InstallPrompt } from "@/components/InstallPrompt";
import { ScrollMemory } from "@/components/ScrollMemory";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { SignInModal } from "@/components/SignInModal";
import { MiniPlayerProvider } from "@/context/MiniPlayerContext";
import { MiniPlayer } from "@/components/MiniPlayer";
import { VisitTracker } from "@/components/VisitTracker";

function AppRoutes() {
  const location = useLocation();
  // Google sign-in returns with #session_id=… — exchange it before any route renders.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/watch/:id" element={<Player />} />
        <Route path="/director/:name" element={<Person kind="director" />} />
        <Route path="/actor/:name" element={<Person kind="actor" />} />
        <Route path="/genre/:tag" element={<Home />} />
        <Route path="/jw-test/:id" element={<Player forceJustWatch />} />
        <Route path="/vault" element={<Vault />} />
        <Route path="/live" element={<Live />} />
        <Route path="/kids" element={<Kids />} />
        <Route path="/tv" element={<TvHandoff />} />
        <Route path="/store" element={<Store />} />
        <Route path="/apk" element={<TvInstall />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/games" element={<Games />} />
        <Route path="/shorts" element={<Shorts />} />
        <Route path="/shorts/feed" element={<ShortsFeed />} />
        <Route path="/partners/stats" element={<PartnerStats />} />
      </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <TvModeProvider>
        <BrowserRouter>
          <AuthProvider>
          <MiniPlayerProvider>
          <ScrollMemory />
          <SpatialNav />
          <ReferralTracker />
          <QuickSearchModal />
          <InstallPrompt />
          <Toaster position="bottom-center" theme="dark" richColors closeButton />
          <ErrorBoundary>
            <AppRoutes />
            <SiteFooter />
          </ErrorBoundary>
          <SignInModal />
          <MiniPlayer />
          <VisitTracker />
          </MiniPlayerProvider>
          </AuthProvider>
        </BrowserRouter>
      </TvModeProvider>
    </div>
  );
}

export default App;
